const PlatformDemoSection = () => {
  return (
    <section className="platform-demo" id="platform">
      <div className="demo-container">
        <div className="section-header">
          <span className="section-label">Platform</span>
          <h2 className="section-title">Platform Capabilities</h2>
        </div>

        <div className="platform-description">
          <div className="description-grid">
            <div className='description-card'>
              <div
                className="description-card-header"
                role="button"
              >
                <h3>CCT Module</h3>
              </div>
              <div
                className="description-card-content"
                id="cct-content"
              >
                <p>
                  Input your steel chemistry to generate a detailed Continuous Cooling Transformation (CCT) diagram in seconds. Ferritico predicts phase evolution such as ferrite, pearlite, bainite, and martensite, along with transformation temperatures and hardness for various cooling rates. This helps teams judge whether a candidate alloy can meet mechanical performance requirements under a given cooling schedule before running a furnace treatment.
                </p>
                <div style={{ marginTop: '1.5rem' }}>
                  <a href="#contact" className="btn-primary">Book CCT Demo</a>
                </div>
              </div>
            </div>
            <div className='description-card'>
              <div
                className="description-card-header"
                role="button"
                tabIndex={0}
              >
                <h3>Additional Simulation Modules</h3>
              </div>
              <div
                className="description-card-content"
                id="beyond-content"
              >
                <p>
                  <strong>Additional simulation modules:</strong> Time Temperature Transformation (TTT) diagrams, Tempering effects on microstructure and hardness, Hardenability, Surface treatments including Carburizing and Nitriding.
                </p>
                <p style={{ marginTop: '1rem' }}>
                  <strong>Custom modeling:</strong> Ferritico can also create custom models for customer-specific needs.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="section-header" style={{ marginTop: '4rem' }}>
          <h2 className="section-title">How the platform works in practice</h2>
        </div>

        <div className="capabilities-grid">
          <div className="capability-item">
            <div className="icon-wrapper"><i class="fi fi-sr-arrows-repeat"></i>
              <div className="icon-bg"></div>
            </div>
            <h4>Continuous improvement</h4>
            <p>Our models are updated continuously with new data and improved methodologies.</p>
          </div>
          <div className="capability-item">
            <div className="icon-wrapper"><i class="fi fi-sr-settings"></i>
              <div className="icon-bg"></div>
            </div>
            <h4>Customer-specific tuning</h4>
            <p>Ferritico can securely incorporate proprietary experimental data to refine predictions for specific steel grades.</p>
          </div>
          <div className="capability-item">
            <div className="icon-wrapper"><i class="fi fi-ss-brain-circuit"></i>
              <div className="icon-bg"></div>
            </div>
            <h4>Hybrid expertise</h4>
            <p>Predictions combine fundamental metallurgy with advanced AI.</p>
          </div>
          <div className="capability-item">
            <div className="icon-wrapper"><i class="fi fi-sr-link"></i>
              <div className="icon-bg"></div>
            </div>
            <h4>Integration-ready</h4>
            <p>A robust API helps integrate Ferritico into existing software and systems.</p>
          </div>
          <div className="capability-item">
            <div className="icon-wrapper"><i class="fi fi-sr-users-alt"></i>
              <div className="icon-bg"></div>
            </div>
            <h4>Interactive and collaborative</h4>
            <p>Teams can tweak parameters, run what-if scenarios, and compare alloys or process conditions in real time.</p>
          </div>
          <div className="capability-item">
            <div className="icon-wrapper"><i class="fi fi-sr-lock"></i>
              <div className="icon-bg"></div>
            </div>
            <h4>Data security and privacy</h4>
            <p>Inputs, results, and custom models are handled through secure cloud architecture and kept confidential.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformDemoSection;
